var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-type-tag"},[_c('div',{staticClass:"offer-type-tag__special-tag",class:( _obj = {}, _obj[("--" + _vm.specialType)] = true, _obj )},[_c('Typography',{attrs:{"variant":"label2","weight":"semibold"}},[_vm._v("\n      "+_vm._s(_vm.specialTypeText)+"\n    ")])],1),(
      _vm.specialType === _vm.SpecialOfferTypeEnum.PRODUCT_AND_SERVICE &&
        _vm.offer.discount.value &&
        !_vm.hideValues
    )?_c('TagSpecialCoin',{staticClass:"offer-type-tag__tag"},[_c('p',[_vm._v("\n      "+_vm._s(_vm.getFormatedDiscount(
          _vm.offer.discount.typeName,
          _vm.offer.discount.value || 5,
          true
        ))+"\n    ")])]):_vm._e(),(
      _vm.specialType === _vm.SpecialOfferTypeEnum.PRODUCT_AND_SERVICE &&
        _vm.offer.discount.value &&
        !_vm.hideValues
    )?_c('div',{staticClass:"offer-type-tag__tag"},[_c('span',{staticClass:"offer-type-tag__value --line"},[_vm._v(_vm._s(_vm.getFormatedDiscount('value', _vm.offer.discount.originalValue || 20)))]),_c('div',{staticClass:"offer-type-tag__divisor"}),_c('span',{staticClass:"offer-type-tag__value"},[_vm._v(_vm._s(_vm.getFormatedDiscount(
        'value',
        _vm.calcDiscount(
          _vm.offer.discount.typeName,
          _vm.offer.discount.originalValue || 20,
          _vm.offer.discount.value || 5
        )
      )))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }